import { render, staticRenderFns } from "./UpdateEmailTemplate.vue?vue&type=template&id=00e4734a"
import script from "./UpdateEmailTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateEmailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports